










import { Component } from "vue-property-decorator";
import Header from "@/components/header/ULoginHeader.vue";
import CategoryList from "@/components/material/Categories.vue";
import Footer from "@/components/Footer.vue";
import CheckUserLogin from "@/utils/CheckUserLogin";

@Component({
  components: {
    Header,
    CategoryList,
    Footer,
  },
})
export default class UCategory extends CheckUserLogin {}
